import { Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ControlsWrapper, ControlGroup, ControlButton, ControlDivider } from '../Styled'

const TreeControls = ({ onZoomIn, onZoomOut, onCenter, onSpreadMore, onSpreadLess, compact = false }) => {
  const { t } = useTranslation()
  return (
    <ControlsWrapper sx={compact ? { gap: 0 } : undefined}>
      {!compact && (
        <ControlGroup>
          <Tooltip title={t('supervision.topology.controls.spread_v', 'Écarter (vertical)')} placement="left">
            <ControlButton onClick={() => onSpreadMore?.('v')}>
              <i className="fa-regular fa-arrows-from-line" style={{ fontSize: 13 }} />
            </ControlButton>
          </Tooltip>
          <ControlDivider />
          <Tooltip title={t('supervision.topology.controls.shrink_v', 'Réduire (vertical)')} placement="left">
            <ControlButton onClick={() => onSpreadLess?.('v')}>
              <i className="fa-regular fa-arrows-to-line" style={{ fontSize: 13 }} />
            </ControlButton>
          </Tooltip>
          <ControlDivider />
          <Tooltip title={t('supervision.topology.controls.spread_h', 'Écarter (horizontal)')} placement="left">
            <ControlButton onClick={() => onSpreadMore?.('h')}>
              <i className="fa-regular fa-arrows-from-line" style={{ fontSize: 13, transform: 'rotate(90deg)' }} />
            </ControlButton>
          </Tooltip>
          <ControlDivider />
          <Tooltip title={t('supervision.topology.controls.shrink_h', 'Réduire (horizontal)')} placement="left">
            <ControlButton onClick={() => onSpreadLess?.('h')}>
              <i className="fa-regular fa-arrows-to-line" style={{ fontSize: 13, transform: 'rotate(90deg)' }} />
            </ControlButton>
          </Tooltip>
          <ControlDivider />
          <Tooltip title={t('supervision.topology.controls.center', 'Centrer')} placement="left">
            <ControlButton onClick={onCenter}>
              <i className="fa-regular fa-arrows-to-circle" style={{ fontSize: 13 }} />
            </ControlButton>
          </Tooltip>
        </ControlGroup>
      )}

      <ControlGroup>
        <Tooltip title={t('supervision.topology.controls.zoom_in', 'Zoom avant')} placement="left">
          <ControlButton onClick={onZoomIn} sx={compact ? { width: 36, height: 32 } : undefined}>
            <i className="fa-regular fa-plus" style={{ fontSize: 13 }} />
          </ControlButton>
        </Tooltip>
        {compact && <ControlDivider />}
        <Tooltip title={t('supervision.topology.controls.zoom_out', 'Zoom arrière')} placement="left">
          <ControlButton onClick={onZoomOut} sx={compact ? { width: 36, height: 32 } : undefined}>
            <i className="fa-regular fa-minus" style={{ fontSize: 13 }} />
          </ControlButton>
        </Tooltip>
      </ControlGroup>
    </ControlsWrapper>
  )
}

export default TreeControls

